import * as React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'

import Checkbox, { CheckboxChangeEvent } from 'antd/es/checkbox'
import Card from 'antd/es/card'
import Divider from 'antd/es/divider'
// import Input from 'antd/es/input'
// import 'antd/lib/checkbox/style/css'
import 'antd/lib/card/style/css'
import 'antd/lib/divider/style/css'
// import 'antd/lib/input/style/css'

import './styles.css'

import BCITProgressTracker from './_projects/bcit-prog-tracker'
import RinkDevTools from './_projects/rink-devtools'
import Regexly from './_projects/regexly'
import Onigasm from './_projects/onigasm'

export interface IProject {
    id: string,
    name: string,
    type: 'app' | 'lib',
    tags: string[],
    containsImages?: boolean,
    containsVideos?: boolean,
    description: JSX.Element
    article?: () => Promise<JSX.Element> | JSX.Element
    links?: Map<string, string>
}

type IProjectShowcaseProps = RouteComponentProps<{}>

interface IProjectShowcaseState {
    projects: IProject[]
    tags: Map<string, number>
    /**
     * To-do: implement tag filters
     */
    activeTags: string[]
}

const defaultState: IProjectShowcaseState = ((): IProjectShowcaseState => {
    const projects = [
        Onigasm,
        Regexly,
        BCITProgressTracker,
        RinkDevTools,
    ]
    const tags = projects.reduce((map, proj) => {
        proj.tags.forEach(tag => {
            if (!map.has(tag)) {
                map.set(tag, 1)
            } else {
                map.set(tag, map.get(tag) as number + 1)
            }
        })
        return map
    }, new Map<string, number>())

    return {
        projects,
        tags: new Map(Array.from(tags.entries()).sort((a, b) => b[1] - a[1])),
        activeTags: Array.from(tags.keys()),
    }
})()

interface ITagFilterProps {
    defaultChecked: string[] | boolean
    tags: Map<string, number>
    onChange: (checkedTags: string[]) => void
}

interface ITagFilterState {
    checked: string[]
    tags: Map<string, number>
    tagsFmtd: Array<{ value: string, label: string }>
}

class TagFilter extends React.PureComponent<ITagFilterProps, ITagFilterState> {

    public static getDerivedStateFromProps(nextProps: ITagFilterProps, prevState: ITagFilterState): ITagFilterState | null {
        if (!prevState || prevState.tags !== nextProps.tags) {
            const { defaultChecked, tags } = nextProps
            return {
                tags: nextProps.tags,
                tagsFmtd: Array.from(tags).map(([tagName, tagOccurences]) => (
                    {
                        label: `${tagName} (${tagOccurences})`,
                        value: tagName,
                    }
                )),
                checked: typeof defaultChecked === 'boolean'
                    ? defaultChecked === true
                        ? Array.from(tags.keys())
                        : []
                    : Array.isArray(defaultChecked)
                        ? defaultChecked
                        : []
            }
        }
        return null
    }

    constructor(props: ITagFilterProps) {
        super(props)
        this.state = TagFilter.getDerivedStateFromProps(props, null)
    }

    public render() {
        const { onChange } = this.props
        const { checked, tags, tagsFmtd } = this.state

        return (
            <div className='tag-filter-container'>
                {/* <Input placeholder='Search tags' /> */}
                {/* <Divider /> */}
                <Checkbox checked={checked.length === tagsFmtd.length} onChange={this.handleSelectAllBox}>Select all</Checkbox>
                <Divider />
                <Checkbox.Group className='chkbox-vertical' options={tagsFmtd} value={checked} onChange={this.handleCheckedListOnChange} />
            </div>
        )
    }

    private handleCheckedListOnChange = (checked: string[]) => {
        this.setState({
            checked
        })

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(checked)
        }
    }

    private handleSelectAllBox = (e: CheckboxChangeEvent) => {
        this.setState({ checked: e.target.checked ? Array.from(this.state.tags.keys()) : [] })
    }
}

export default class ProjectShowcase extends React.PureComponent<IProjectShowcaseProps, IProjectShowcaseState> {
    // public static getDerivedStateFromProps(nextProps: IProjectShowcaseProps, prevState: IProjectShowcaseState): IProjectShowcaseState | null {
    //     return null
    // }

    constructor(props: IProjectShowcaseProps) {
        super(props)
        this.state = defaultState
    }

    public render() {
        const { activeTags, tags, projects } = this.state
        return (
            <div className='project-showcase'>
                {/* <div className='filter-sidebar'>
                    <TagFilter defaultChecked={activeTags} tags={tags} onChange={this.handleTagFilterChange} />
                </div> */}
                <div className='project-list'>
                    <ul>
                        {
                            projects.map(proj => {
                                const { id, description, name, tags: projTags, links } = proj
                                return (
                                    <li key={id} className='proj-entry'>
                                        <Card title={<h2 style={{margin: '0'}}>{name}</h2>} bodyStyle={{padding: '12px 10px'}}>
                                            {projTags.map(t => (<span className='proj-tag' key={t}>{t}</span>))}
                                            <Divider style={{margin: '12px 0'}}/>
                                            {description}
                                            {links ? <Divider /> : null}
                                            {
                                                links ?
                                                    <ul className='project-links'>
                                                        {Array.from(links).map(([text, url]) =>
                                                            <li key={url}><a href={url}>{text}</a></li>
                                                        )}
                                                    </ul>
                                                    : null
                                            }
                                        </Card>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }

    private handleTagFilterChange = (checkedTags: string[]) => {
        //
    }
}



// WEBPACK FOOTER //
// ./src/components/Projects/index.tsx